<template>
  <div class="emd-container _highlight_header !shadow-none">
    <div
      class="emd-container__header"
      v-if="title"
    >
      <h2
        class="emd-text _size_section"
        data-testid="title"
      >
        {{ title }}
      </h2>
    </div>
    <div :class="{ 'emd-container__content': !removePadding }">
      <emd-alert
        v-if="showAlert"
        :variant="'danger'"
        :title="$t('account.settings.alert.error-title')"
        data-testid="alert"
        @cancel="showAlert = false"
      >
        <template slot="content">
          <div>
            <p
              data-testid="error"
              v-for="(error, index) in errors"
              :key="index"
            >
              {{ error }}
            </p>
          </div>
        </template>
      </emd-alert>
      <component
        v-for="(form, index) in formsOnShell"
        v-show="form?.show ?? true"
        v-bind="form"
        :is="form.name"
        :key="index"
        :ref="form.name"
        :formOpenHoursValid.sync="formOpenHoursValid"
      ></component>
    </div>
    <div
      data-testid="buttons"
      class="emd-container__footer eu-justify_end"
      v-if="!onlyFields"
    >
      <button
        class="emd-btn _color_primary _type_text"
        type="button"
        data-testid="cancel"
        :disabled="isLoading"
        @click="cancelForm"
      >
        {{ $t('buttons.cancel') }}
      </button>
      <button
        class="emd-btn _color_primary"
        tabindex="0"
        data-testid="confirm"
        :disabled="!formOpenHoursValid"
        @click="confirmForm"
      >
        <span>{{ $t('buttons.request') }}</span>
      </button>
    </div>
    <modal-password
      v-if="modalPasswordIsOpen"
      data-testid="modal-password"
      :textButtonSubmit="$t('buttons.request')"
      :callback="sendRequestWithPassword"
      @cancel="hideModalPassword"
    ></modal-password>
    <modal-success
      v-if="modalSuccessIsOpen"
      data-testid="modal-success"
      :title="successTexts.title"
      :info="successTexts.info"
      :content="successTexts.content"
      @onCancel="handleSuccessModalButton"
      @onSubmit="handleSuccessModalButton"
    />
    <component
      v-if="modalPreValidationIsOpen"
      v-bind="preValidation.props"
      :is="preValidation.component"
      @onCancel="modalPreValidationIsOpen = false"
      @onSubmit="handleSubmitPreValidation"
    ></component>
  </div>
</template>
<script>
import { formatErrorMessage } from '@/support/formatErrorMessage'
import { EmdAlert } from 'emerald-vue/src/components'

import PhysicalWorldFormDTO from '@/views/PhysicalWorld/PhysicalWorldFormDTO'

export default {
  name: 'FormShell',
  components: {
    EmdAlert,
    FormRollQuantity: () =>
      import('@/views/PhysicalWorld/components/FormRollQuantity.vue'),
    FormReceivers: () =>
      import('@/views/PhysicalWorld/components/FormReceivers.vue'),
    FormAddress: () =>
      import('@/views/PhysicalWorld/components/FormAddress.vue'),
    FormOpenHours: () =>
      import('@/views/PhysicalWorld/components/FormOpenHours.vue'),
    FormTerminalData: () =>
      import('@/views/PhysicalWorld/components/FormTerminalData.vue'),
    FormObservation: () =>
      import('@/views/PhysicalWorld/components/FormObservation.vue'),
    ModalPassword: () =>
      import('@/components/project/globals/ModalPassword.vue'),
    ModalSuccess: () => import('@/components/project/globals/ModalInfo.vue'),
    ModalUninstallTerminal: () =>
      import('@/views/PhysicalWorld/components/ModalUninstallTerminal.vue')
  },
  props: {
    title: String,
    successTexts: Object,
    callbackRequest: Function,
    preValidation: Object,
    formsOnShell: Array,
    makeBodyToRequest: Function,
    onlyFields: Boolean,
    removePadding: Boolean
  },
  data () {
    return {
      showAlert: false,
      isLoading: false,
      errors: [],
      modalSuccessIsOpen: false,
      modalPasswordIsOpen: false,
      modalPreValidationIsOpen: false,
      requestData: {},
      formOpenHoursValid: false
    }
  },
  methods: {
    async sendRequestWithPassword (password) {
      try {
        await this.callbackRequest({
          body: { ...this.makeBodyToRequest(), password }
        })

        this.modalSuccessIsOpen = true
      } catch (err) {
        window.scrollTo({ top: 0, behavior: 'smooth' })

        const msgErrorInternal = this.$t('account.settings.error-internal')

        this.errors = formatErrorMessage(err, msgErrorInternal)
        this.showAlert = true
      } finally {
        this.modalPasswordIsOpen = false
      }
    },
    hideModalPassword () {
      this.modalPasswordIsOpen = false
    },
    handleSubmitPreValidation () {
      this.modalPreValidationIsOpen = false
      this.modalPasswordIsOpen = true
    },
    handleSuccessModalButton () {
      this.$router.push({ name: 'service-orders' })
    },
    cancelForm () {
      this.$emit('cancel')
    },
    confirmForm () {
      new PhysicalWorldFormDTO().reset()

      this.formsOnShell.forEach(({ name }) => {
        this.$refs[name][0].submitEmitter()
      })

      const physicalWorldFormDTO = new PhysicalWorldFormDTO()

      if (physicalWorldFormDTO.hasError()) {
        return null
      }

      if (this.preValidation) {
        this.modalPreValidationIsOpen = true
        return null
      }

      this.modalPasswordIsOpen = true
    }
  }
}
</script>
<i18n>
  {
    "pt-BR": {
      "buttons": {
        "request": "Solicitar",
        "cancel": "Cancelar"
      },
      "alert": {
        "sucess-request": "Solcitado com sucesso"
      }
    },
    "en-US": {
      "buttons": {
        "request": "Request",
        "cancel": "Cancel"
      },
      "alert": {
        "sucess-request": "Request sent successfully"
      }
    }
  }
</i18n>
